import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "@/components/storefront/PageHeader";
import { ProductCard } from "@/components/storefront/ProductCard";
import { Seo } from "@/components/Seo";
import { Button } from "@/components/ui/button";
import { usePageContent } from "@/context/SiteContext";
import { API, imgUrl } from "@/lib/api";

export default function Funerals() {
  const content = usePageContent("funeral_page");
  const homeContent = usePageContent("home");
  const [products, setProducts] = useState([]);

  useEffect(() => {
    API.get("/products", { params: { category: "funeral-tributes" } }).then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="funerals-page">
      <Seo title={content?.seo_title} description={content?.seo_description} />
      <PageHeader title={content?.title || "Funeral Tributes"} subtitle={content?.intro} testId="funerals-header" />
      <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-10 items-start">
        {content?.image && <img src={imgUrl(content.image)} alt="Funeral tribute flowers" className="rounded-xl aspect-[4/3] object-cover w-full" data-testid="funerals-image" />}
        <div>
          {(content?.body || "").split("\n\n").map((p, i) => (
            <p key={i} className="text-muted-foreground leading-relaxed mb-4">{p}</p>
          ))}
          <Button asChild className="rounded-full mt-2" data-testid="funerals-browse-btn">
            <Link to="/shop?category=funeral-tributes">{content?.cta_label || "Browse Tributes"}</Link>
          </Button>
        </div>
      </div>
      {homeContent?.show_hg !== false && (
        <div className="max-w-5xl mx-auto px-4 mt-12" data-testid="funerals-hg">
          <div className="rounded-2xl border bg-secondary/50 dark:bg-secondary/15 p-6 flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left">
            {homeContent?.hg_logo && (
              <div className="bg-white rounded-xl p-2.5 shadow-sm shrink-0">
                <img src={imgUrl(homeContent.hg_logo)} alt="Heavenly Gems logo" className="h-12 w-auto" />
              </div>
            )}
            <div className="flex-1">
              <h2 className="font-display text-xl tracking-tight">Memorial keepsakes</h2>
              <p className="mt-1 text-sm text-muted-foreground">
                For something to treasure forever, our friends at Heavenly Gems handcraft memorial jewellery in South Wales — created with ashes, fingerprints or handwriting to keep your loved ones close.
              </p>
            </div>
            <Button asChild variant="outline" className="rounded-full shrink-0" data-testid="funerals-hg-link">
              <a href={homeContent?.hg_link || "https://heavenlygems.co.uk"} target="_blank" rel="noreferrer">Visit Heavenly Gems</a>
            </Button>
          </div>
        </div>
      )}
      {products.length > 0 && (
        <div className="max-w-7xl mx-auto px-4 mt-16" data-testid="funerals-products">
          <h2 className="font-display text-3xl tracking-tight mb-8">Tributes</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        </div>
      )}
    </div>
  );
}
